import axios from 'axios';
import c from '../helpers/constants';

export function getProductTypes(customerId: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.PRODUCT_TYPES}?customerid=${customerId}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
